import React, { useRef } from 'react';
import { CATEGORIES } from '../data/menuData';
interface CategoryNavProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
export function CategoryNav({
  activeCategory,
  onSelectCategory
}: CategoryNavProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleSelect = (category: string) => {
    onSelectCategory(category);
    // Scroll selected chip into view
    const el = scrollRef.current?.querySelector(`[data-cat="${category}"]`) as HTMLElement;
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };
  return <div className="sticky top-0 z-20 bg-background/95 backdrop-blur-sm py-2 px-4 -mx-4 mb-4" data-id="element-108">
      <div ref={scrollRef} className="flex overflow-x-auto hide-scrollbar gap-2 pb-1" style={{
      touchAction: 'pan-x',
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-109">
        <button data-cat="Todos" onClick={() => handleSelect('Todos')} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === 'Todos' ? 'bg-verde text-white shadow-md' : 'bg-white text-gray-600 border border-gray-200'}`} data-id="element-110">
          Todos
        </button>
        {CATEGORIES.map(category => <button key={category} data-cat={category} onClick={() => handleSelect(category)} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === category ? 'bg-verde text-white shadow-md' : 'bg-white text-gray-600 border border-gray-200'}`} data-id="element-111">
            {category}
          </button>)}
      </div>
    </div>;
}